import React, { useEffect } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Img from "../Assets/img/consult-img.webp";
import { Je_welryspelling } from "../../../../Helpers/request";

const ConsultSpecialist = () => {
  return (
    <section className="consult-specialist-section section-space">
      <Container fluid className="showcase-container">
        <div>
          <Row>
            <Col md={6} className="px-0">
              <div className="inner-wrap text-center">
                {/* <span>Feel Free To Talk With Us</span> */}
                <h2> About Montgomery Jewelers</h2>
                <p>
                  Welcome to Montgomery Jewelers, your trusted destination for exquisite Diamonds and Fine Jewelry. With our experience, we pride ourselves on providing exceptional service and unparalleled quality to our valued customers.
                </p>
                <Link
                  className="btn outline-base-btn large"
                  to="/our-story"
                >
                  Know More
                </Link>
              </div>
            </Col>
            <Col md={6} className="text-center px-0">
              <Image src={Img} alt="Feel Free To Talk With Us" className="img-fluid" />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default ConsultSpecialist;
